import { render, staticRenderFns } from "./QuickShipperInvoiceUnitQtyModal.vue?vue&type=template&id=63f56489&scoped=true"
import script from "./QuickShipperInvoiceUnitQtyModal.vue?vue&type=script&lang=js"
export * from "./QuickShipperInvoiceUnitQtyModal.vue?vue&type=script&lang=js"
import style0 from "./QuickShipperInvoiceUnitQtyModal.vue?vue&type=style&index=0&id=63f56489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f56489",
  null
  
)

export default component.exports